module.exports = __webpack_public_path__ + "static/media/play.1c61590f.svg";